<template>
   <div class="group">
       <slot></slot>
   </div>
</template>

<script>
export default {
    name:'g-button-group',
    mounted(){
        for(var i = 0 ;i<this.$el.children.length;i++){
            if(this.$el.children[i].nodeName !== 'BUTTON'){
                console.warn('g-group-button里面的元素应使用g-button')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../var';
.group{
    display: inline-flex;
    vertical-align: middle;
    >.g-button{
        border-radius:0;
        margin-left:-1px;
        // &:not(first-child){
        //     margin-left:0;
        // }
        &:hover{
            position:relative;
            z-index:1;
        }
        &:first-child{
            border-top-left-radius:$border-radius;
            border-bottom-left-radius:$border-radius;
        }
        &:last-child{
            border-top-right-radius:$border-radius;
            border-bottom-right-radius:$border-radius;
        }
    }
}
</style>>